module.exports = __webpack_public_path__ + "img/step-four-img.fb4d53e.svg";